module.exports = __webpack_public_path__ + "img/owl.4d38ea8a.png";